import React from 'react';

const Arrow = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 16">
        <path
            fill="currentColor"
            fillRule="nonzero"
            d="M16.617 7.057 10.078.391a1.29 1.29 0 0 0-1.849 0c-.51.52-.51 1.364 0 1.885l4.306 4.39H1.308A1.32 1.32 0 0 0 0 8a1.32 1.32 0 0 0 1.308 1.333h11.227L8.23 13.724c-.51.52-.51 1.365 0 1.885a1.29 1.29 0 0 0 1.85 0l6.538-6.666c.51-.521.51-1.365 0-1.886Z"
        />
    </svg>
);

export default Arrow;
